export default "Vendicated/Vencord"